import React from "react";
import { Routes, Route } from "react-router-dom";
import { ListaAtivos, Ativos, Ativo } from "../../../pagesPublic";

const AtivosRoutes = () => {
  return (
    <Routes>
      <Route exact path={"busca/page/:page"} element={<Ativos />} />
      <Route exact path={"busca"} element={<Ativos />} />
      <Route exact path={`:id/*`} element={<Ativo />} />
      <Route path={"*"} element={<ListaAtivos />} />
    </Routes>
  );
};

export default AtivosRoutes;
